<app-inventory-template
  [inventoryOptions]="{
    items_load_endpoint: 'load_king_inventory',
    items_search_enabled: true,
    items_sort_enabled: true,
    items_pure_filter_enabled: false,
    typography_action_button: 'Join King',
    typography_title: 'Join King',
    }"
  [requirementsOptions]="{
        requirements_title: 'Join King',
        requirements_accent_word: 'bet',
        requirements_options_min_value: 2,
        requirements_options_max_value: 5000,
        requirements_options_min_items: 1,
        requirements_options_max_items: 20,
    }"
  [inventorySkinsListConfig]="{ mobile: { skin_min_width: '150px' } }"
  [(selectedSkins)]="selectedSkins"
  (action)="joinKing()"
  [isProcessing]="isProcessing()"
  [balanceType]="'skins'"
>
  <ng-content inventory-top>
    <div class="divider vertical h-full"></div>

    <div class="deposit-king--toggle-group">
      <button
        class="deposit-king--toggle-group__button"
        [class.selected]="type() === 'fight'"
        (click)="toggleType()"
      >
        Fight Mode
        <svg-icon
          class="flex items-center justify-center s-14"
          src="assets/icons/shared/info.svg"
          [ngpTooltipTrigger]="fightModeTooltip"
          [ngpTooltipTriggerOffset]="18"
          [ngpTooltipTriggerHideDelay]="0"
        ></svg-icon>
        <ng-template #fightModeTooltip>
          <div
            class="tooltip"
            ngpTooltip
            style="z-index: 1001; max-width: 300px"
          >
            Fight Mode: you risk all of your winnings and your deposit, but your
            Max HP also increases with every win.
          </div>
        </ng-template>
      </button>
      <button
        class="deposit-king--toggle-group__button"
        [class.selected]="type() === 'vault'"
        (click)="toggleType()"
      >
        Vault Mode
        <svg-icon
          class="flex items-center justify-center s-14"
          src="assets/icons/shared/info.svg"
          [ngpTooltipTrigger]="vaultModeTooltip"
          [ngpTooltipTriggerOffset]="18"
          [ngpTooltipTriggerHideDelay]="0"
        ></svg-icon>
        <ng-template #vaultModeTooltip>
          <div
            class="tooltip"
            ngpTooltip
            style="z-index: 1001; max-width: 300px"
          >
            Vault Mode: you only risk your deposit. Your winnings are secured
            but your Max HP remains the same until you flee or lose to someone.
          </div>
        </ng-template>
      </button>
    </div>
  </ng-content>
</app-inventory-template>
